module.exports = __webpack_public_path__ + "static/media/unavailable-active.15ca159a.svg";